module.exports = __webpack_public_path__ + "static/media/Reef Capital Ad Large.ae0b2992.webp";